export default __webpack_public_path__ + "static/media/dogs.8a73617d.svg";